import { useEffect, useState } from 'react';
import { createBlock } from '../../../DocEditor';
import { SopAPI } from '../../../../utils/api';
import { useDocVariablesLiveSync } from '../../../../hooks/useDocVariablesLiveSync';

/**
 * Fetches the full doc body on open. The library list only carries metadata.
 * Previous doc stays mounted across in-sheet navigation (caller keeps chrome).
 */
export function useDocLoad(docId) {
  const [doc, setDoc] = useState(null);
  const [blocks, setBlocks] = useState([]);
  const [title, setTitle] = useState('');
  const [loadError, setLoadError] = useState('');
  const [docVariables, setDocVariables] = useState([]);
  const [variablesColumnWidths, setVariablesColumnWidths] = useState(null);
  useDocVariablesLiveSync(docId, setDocVariables);

  useEffect(() => {
    let cancelled = false;
    setLoadError('');
    SopAPI.get(docId)
      .then((full) => {
        if (cancelled) return;
        setDoc(full);
        setTitle(full.title || '');
        setDocVariables(Array.isArray(full.variables) ? full.variables : []);
        setVariablesColumnWidths(
          Array.isArray(full.variablesColumnWidths) ? full.variablesColumnWidths : null
        );
        setBlocks(
          Array.isArray(full.body) && full.body.length > 0
            ? full.body
            : [createBlock('text')]
        );
      })
      .catch((e) => {
        if (!cancelled) setLoadError(e.message || 'Failed to load Doc');
      });
    return () => {
      cancelled = true;
    };
  }, [docId]);

  return {
    doc,
    setDoc,
    blocks,
    setBlocks,
    title,
    setTitle,
    loadError,
    docVariables,
    setDocVariables,
    variablesColumnWidths,
    setVariablesColumnWidths,
  };
}
